import owd from 'owd/owd';

export default class Tabs extends owd.Component {
	init() {
        this.buttons = this.$element.find('[data-tabs-button]');
        this.tabs = this.$element.find('[data-tabs-tab]');
        this.tabsChart = this.$element.find('.tabs-chart');
        //console.log(this.buttons, this.tabs);
        //this.idTab = this.$element.data('tab');
        //this.tab = $(`#${this.idTab}`);
        
        this.initAttribiutes();
		this.bind();
	}
    
    initAttribiutes() {
        this.buttons.each((i, button) => {
            button = $(button);
            
            button.attr({
                'role': 'tab',
                'aria-controls': button.data('tab'),
                'aria-selected': false
            });
        });
        
        this.tabs.each((i, tab) => {
            tab = $(tab);
            
            tab.attr({
                'role': 'tabpanel',
                'aria-hidden': true
            });
        });
    }

	bind() {
        this.on('click', this.buttons, (e) => {
            e.preventDefault();
            
            const target = $(e.currentTarget);
            const tab = $(`#${target.data('tab')}`);
            
            this.buttons.removeClass('is-active');
            this.tabs.removeClass('is-active');
            this.buttons.attr('aria-selected', false);
            this.tabs.attr('aria-hidden', true);
            //$('.button--tab, .tab').removeClass('is-active');
            //$('.button--tab').attr('aria-selected', false);
            //$('.tab').attr('aria-hidden', true);
            
            target.toggleClass('is-active');
            tab.toggleClass('is-active');
            //this.$element.toggleClass('is-active');
            //this.tab.toggleClass('is-active');
            
            const state = target.hasClass('is-active')
            //const state = this.$element.hasClass('is-active')
            
            tab.attr('aria-hidden', !state)
            target.attr('aria-selected', state);
            
            if(this.tabsChart.hasClass('is-visible')) {
                this.tabsChart.removeClass('is-visible');
            }
            //this.tab.attr('aria-hidden', !state)
            //this.$element.attr('aria-selected', state);
        });

        if(this.$element.parent().find('.button--tab').first()) {
            //this.$element.trigger('click');
        }
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('tabs', {
	component: Tabs
});
